import React, { FC } from 'react';
import { IntlProvider } from 'react-intl';
import { CURRENTLY_HARDCODED_LOCALE } from './constants';

// Format intl message with currency format: $1,000.00
// const customFormats = {
//     number: {
//         NZD: {
//             style: 'currency',
//             currency: 'NZD',
//         },
//     },
// };

export const Internationalization: FC<{ children: React.ReactNode }> = ({
    children,
}) => (
    <IntlProvider
        locale={CURRENTLY_HARDCODED_LOCALE}
        defaultLocale={CURRENTLY_HARDCODED_LOCALE}
        // TODO: https://github.com/formatjs/formatjs/issues/3981
        // defaultFormats={customFormats}
    >
        {children}
    </IntlProvider>
);
